import React, { PureComponent } from 'react';

const instances = new Map();

let bodyOverflowStyle;

class ScrollLock extends PureComponent {
    static registerInstance = instance => {
        if (instances.size === 0) {
            ScrollLock.setBodyOverflow(true);
        }

        instances.set(instance.$node, instance);
    }

    static unregisterInstance = instance => {
        instances.delete(instance.$node);

        if (instances.size === 0) {
            ScrollLock.setBodyOverflow(false);
        }
    }

    static setBodyOverflow(shouldLock) {
        if (shouldLock) {
            // Save the `overflow` property, just in case it was set to something other than a default.
            bodyOverflowStyle = document.body.style.overflow;
            // Force `overflow:hidden`; this will freeze the document scrolling position but hide the scrollbars.
            document.body.style.overflow = 'hidden';
        } else {
            // Re-apply old body overflow.
            document.body.style.overflow = bodyOverflowStyle;
        }
    }

    componentDidMount() {
        ScrollLock.registerInstance(this);
    }

    componentWillUnmount() {
        ScrollLock.unregisterInstance(this);
    }

    render() {
        return (
            <span
                ref={node => { this.$node = node; }}
                data-test="scroll-lock"
                hidden
            />
        );
    }
}

export {
    ScrollLock as default,
    ScrollLock,
};
